import * as path from "../paths";
import { client } from "../client";

export const createHashtag = (data) => {
  return client
    .post(path.CREATE_HASHTAG, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getHashtag = (tag) => {
  return client
    .get(`${path.GET_HASHTAG}/${tag}`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getHashtagMembers = (tag, page = 1, limit = 20) => {
  return client
    .get(`${path.GET_HASHTAG}/${tag}/members?page=${page}&limit=${limit}`)
    .then((result) => result)
    .catch((err) => err.response);
};

export const updateHashtag = (tag, data) => {
  return client
    .put(`${path.GET_HASHTAG}/${tag}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const joinHashtag = (tag) => {
  return client
    .post(`${path.GET_HASHTAG}/${tag}/join`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const leaveHashtag = (tag) => {
  return client
    .post(`${path.GET_HASHTAG}/${tag}/leave`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
